import { type ScopedProps, useCardCategoryContext } from '../../card-category'
import { cardCategoryLabelVariants } from '../../card-category.styles'
import type { CardCategoryProps } from '../../card-category.types'

type TLabelProps = Omit<CardCategoryProps, 'orientation'>

export const Label = (props: TLabelProps) => {
  const { __scopeCardCategory, children } = props as ScopedProps<TLabelProps>
  const { orientation, context, disabled, isPressed, isHovered } =
    useCardCategoryContext('CardCategoryLabel', __scopeCardCategory)
  return (
    <span
      className={cardCategoryLabelVariants({
        orientation,
        context,
        disabled,
        isPressed,
        isHovered,
      })}
    >
      {children}
    </span>
  )
}
